class SessionStorageService {
    Get(key) {
        var item = sessionStorage.getItem(key);
        if (item) {
            return JSON.parse(item);
        }
        return null;
    }

    Set(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    delete(key) {
        sessionStorage.removeItem(key);
    }
}

export default SessionStorageService;
